import { hasPermission } from './Permissions'

export const canViewSecomRecords = () => hasPermission('secom.view')

export const canEditSecomRecords = () => hasPermission('secom.edit')

export const canViewSecomFicha = () => hasPermission('secom.view_ficha')

export const canSecomUpdates = () => hasPermission('secom.updates')

export const canSecomReports = () => hasPermission('secom.reportes')

export const canSecomCatalogos = () => hasPermission('secom.catalogos')

export function hasAnySecomMenuAccess() {
    return (
        canViewSecomRecords() ||
        canEditSecomRecords() ||
        canViewSecomFicha() ||
        canSecomUpdates() ||
        canSecomReports() ||
        canSecomCatalogos()
    )
}
